<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="recordNav">
        <p>
          处罚结果
        </p>
        <div style="display:flex;">
          
          <p v-if="theBlack.punish_id" style="cursor:pointer;color:#4CD964;margin-left:10px" @click="lookApply()">
            查看处罚申请详情
          </p>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="recordMain">
        <yioks-loading v-show="loading"></yioks-loading>
        <div v-if="!loading" class="Info">
          <vue-scroll :ops="ops" ref="vs">
            <div
              class="mainInfo"
              v-if="true"
            >
              <template >
                <div class="title" style="justify-content: space-between">
                  <div style="display: flex">
                      <v-icon class="logo" name="user" scale="1.6"></v-icon>
                      <p class="titleInfo">
                        处罚人信息
                      </p>
                  </div>
                  <div>
                    <p v-if="Number(theBlack.is_deleted)===0 && ['system', 'super', 'sysFive', 'supFive'].includes(member_type)" style="cursor:pointer;color:#4CD964;font-size:16px" @click="editOver()">
                      编辑处罚结果
                    </p>
                  </div>
                </div>
                <div class="perInfo">
                  <template>
                    <el-row class="score-row">
                      <el-col :span="8" class="score-col">
                        <p>姓名(中文)：{{theBlack.name}}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>证件号：{{theBlack.id_number}}</p>
                      </el-col>
                      <el-col :span="8" class="score-col">
                        <p>手机号：{{theBlack.mobile_phone || '--'}}</p>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </template>
              
              <template>
                <div class="title">
                  <v-icon
                    class="logo"
                    name="regular/address-book"
                    scale="1.6"
                  ></v-icon>
                  <p class="titleInfo" style="color: red">处罚结果</p>
                </div>
                <div
                  class="recordInfo"
                >
                  <el-row class="score-row">
                    <el-col :span="8" class="score-col">
                      <p>处罚类型：{{theBlack.type | userType}}</p>
                    </el-col>
                    <el-col :span="8" class="score-col">
                      <p>生效日期：{{theBlack.start_date}}</p>
                    </el-col>
                    <el-col :span="8" class="score-col">
                      <p>解禁日期：{{theBlack.end_date || '永久封禁'}}</p>
                    </el-col>
                  </el-row>
                  
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>处罚依据：{{theBlack.basis}}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>处罚结果：{{theBlack.behavior}}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row">
                    <el-col :span="24" class="score-col">
                      <p>备注：{{theBlack.remark || '--'}}</p>
                    </el-col>
                  </el-row>
                  <el-row class="score-row" v-if="theBlack.document_list.length > 0">
                    <el-col :span="24" class="score-col">
                      <template v-for="(item,index) in theBlack.document_list">
                        <p>
                          证明材料{{index+1}}：
                          <span v-if="item.document_address" style="color: #4cd964"
                          ><a target="_blank" :href="item.document_address"
                          >（点击查看证明材料）</a
                          >
                        </span>
                          <span v-else>暂未上传证明材料</span>
                        </p>
                      </template>
                      
                    </el-col>
                    
                  </el-row>
                  <el-row class="score-row" v-else>
                    <el-col :span="24" class="score-col">
                      <p>证明材料：<span>暂未上传证明材料</span></p>
                    </el-col>
                  </el-row>
                  
                </div>
              </template>
            </div>
            <div v-else>
              <yioks-empty
                tips="数据不存在，请返回上一步重新查询。"
              ></yioks-empty>
            </div>
            <template v-if="showEditBlackListDetail">
              <black-list :Info="Info" :title="Title" :showBlackListDialog="showEditBlackListDetail" :notEdit="notEdit" @hideTips="hideTips"></black-list>
            </template>
          </vue-scroll>
        </div>
      </div>
    </template>
  </tea-main>
</template>

<script>
import classSrc from "@/assets/images/class_logo.png";
import {viewPunishInfo} from "@/api/agency/agency";
import { storageData } from "@/assets/js/storage";
import ops from "@/assets/js/vuescrollOption";
import "vue-awesome/icons/user";
import "vue-awesome/icons/regular/address-book";
import "vue-awesome/icons/tags.js";
import "vue-awesome/icons/regular/clock";
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import placePhoto from "@/assets/images/person.png";
import fiveMixins from "@/minix/fiveMixins";
import {punishStatus} from "@/assets/js/yioksFilters";
import {punishPeopleAudit,viewBlackInfo} from "@/api/system_manager/api";

export default {
  name: "punishResultInfo",
  mixins: [fiveMixins],
  data() {
    return {
      identify1,
      identify2,
      placePhoto,
      classSrc,
      black_id: this.$route.query.black_id,
      theBlack:{},
      blackListInfo:{},
      auditInfo:{},
      ops: ops(),
      loading: true,
      the_quality: "futsal",
      showEditBlackListDetail:false,
      Info:{},
      notEdit:false,
      Title:'处罚人员详情',
    };
  },
  computed: {
  
  },
  created() {
    const member_type = storageData.getUserInfo().member_type;
    const token = storageData.getToken();
    this.member_type = member_type;
    this.getPunishInfo();
  },
  methods: {
    
    getPunishInfo(){
  
      viewBlackInfo(this.black_id).then((res) => {
        if(Number(res.data.status) === 0){
          this.$set(this.theBlack,"document_list",res.data.result.documentList);
          let { behavior,basis, ...rest} = res.data.result.theBlack;
          this.theBlack = Object.assign({}, this.theBlack, rest)
          let behaviorShow = '';
          let basisShow = '';
          if(res.data.result.theBlack.behavior){
            // 如果解析报错请 参考 experienceFilter 方法；
            const temList = JSON.parse(res.data.result.theBlack.behavior)
            temList.forEach(letTmp =>{
              if(letTmp){
                let tmp1 = letTmp[0] + '/' +letTmp[1] +'，'
                behaviorShow = behaviorShow + tmp1;
              }
            })
          }
          behaviorShow = behaviorShow.substr(0, behaviorShow.length - 1);
          this.theBlack.behavior=behaviorShow;
          
          if(res.data.result.theBlack.basis){
            // 如果解析报错请 参考 experienceFilter 方法；
            const temList = JSON.parse(res.data.result.theBlack.basis)
            temList.forEach(letTmp =>{
              if(letTmp){
                let tmp1 = letTmp[0] + '/' +letTmp[1] +'，'
                basisShow = basisShow + tmp1;
              }
            })
          }
          basisShow = basisShow.substr(0, basisShow.length - 1);
          this.theBlack.basis=basisShow;
          
          this.loading = false;
        }else{
          this.$message.error(res.data.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
  
    lookApply() {
      this.$router.push({
        path: 'punishApply',
        query: {punish_id: this.theBlack.punish_id}
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    editOver(){
      this.Info=this.theBlack;
      this.Title='编辑处罚人员';
      this.notEdit=false;
      this.showEditBlackListDetail=true;
    },
    hideTips(bool,flag){
      this.showEditBlackListDetail=bool;
      if (flag){
        this.$message.success('编辑处罚人员成功！')
        this.getPunishInfo()
      }
    },
    imgListErr(idx) {
      this.$set(this.list[idx], "moment_picture", this.imgSrc);
    },
    
    
    
    
    imgError(type) {
      if (type === "photo") {
        this.$set(this.recordInfo, "profile_picture", this.placePhoto);
      } else if (type === "front") {
        this.$set(this.recordInfo, "id_card_photo_front", this.identify1);
      } else if (type === "verson") {
        this.$set(this.recordInfo, "id_card_photo_verso", this.identify2);
      }
    },
   
    
  },
  filters: {
    userType(type){
      switch (type) {
        case 'fakes' :return '培训处罚';break;
        case 'punish':return '纪律处罚';break;
        case 'other':return '其他';break;
      }
    },
  },

  components: {
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-verify": () => import("@/components/Tips/verify-adjust"),
    "yioks-status": () => import("@/components/Tips/Status"),
    BlackListDialog: () => import("@/components/Tips/addBlackList"),
    "yioks-dialog": () => import("@/components/Tips/Dialog"),
    "add-dialog": () => import("@/views/Documents/components/AddDialog"),
    "edit-enter-enroll": () =>
      import("@/components/Qualification/edit-enter-enroll"),
    "black-list" : () => import("@/components/Tips/edit_and_look_blackList"),
    
  },
};
</script>

<style scoped lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/nav_filter'
.recordNav, .recordMain
  flex 1 1 auto
  height 100%
.recordNav
  display flex
  justify-content space-between
  align-items center
  padding 0 12px 0 0
  font-size $font_size_big
  .audit
    display flex
    justify-content center
    align-items center
    padding 5px 15px
    font-size 16px
    background-color $color_suc
    cursor pointer
.recordMain
  width 100%
  padding 25px 0 25px 0
  background-color $block_bg_color_base
  .Info
    padding 0 0 0 40px
    height 550px
    .mainInfo
      padding-right 40px
      padding-top 5px
      .zuxie-btn
        background-color $color_suc
        width 80px
        padding 10px 4px
        
      .perInfo, .recordInfo
        position relative
        margin-bottom 40px
        border 1px solid $color_white
        .score-row
          border-bottom 1px solid $color_white
          .score-table
            .row
              border-bottom 1px solid $color_white
              display flex
              &:last-child
                border-bottom none
              .score-col
                
                border-left 1px solid $color_white
                flex auto
                &:first-child
                  border-left none
                p
                  margin 10px
                  font-size $font_size_medium
                  word-break break-all
                  &.score-note
                    text-align left
          &:last-child
            border-bottom none
          .score-col
            
            border-left 1px solid $color_white
            &:first-child
              border-left none
            p
              margin 10px
              font-size $font_size_medium
              word-break break-all
              &.score-note
                text-align left
        .dashed-line
          width 100%
          position absolute
          bottom -22px
          left 0
          border 1px dashed $color_white
        &:last-child
          margin-bottom 0
      
      .title
        display flex
        margin-bottom 10px
        .titleInfo
          margin-left 10px
          font-size 18px
          line-height 1.6
      .timeline
        display block
        padding-left 3px
        .timeline-item
          position relative
          padding-bottom 20px
          .item_tail
            position absolute
            top 36px
            bottom 6px
            left 16px
            // height 100%
            border-left 2px solid #cccccc
          .item_node
            position absolute
            background-color #fff
            color #333
            border 1px solid #fff
            border-radius 50%
            // left -2px
            width 36px
            height @width
            font-size 12px
            display flex
            align-items center
            text-align center
            justify-content center
          .item_wrap
            position relative
            padding-left 50px
            top -3px
            .timestamp
              display flex
              // align-items center
              line-height 1
              margin-bottom 5px
              font-size 15px
              .audit_people
                flex 1
                text-align right
                margin-left 10px
            .item_cont
              display block
              background-color #fff
              color #333
              padding 10px
              border-radius 4px
              border 1px solid #cccccc
              overflow hidden
              font-size 15px
              box-shadow 0 2px 12px 0 rgba(255, 255, 255, 0.1)
      .intro_data
        border 1px dashed $color_white
        padding-left 370px
        height 12px
        font-size 16px
        margin-bottom 20px
      .el-tag + .el-tag
        margin-left 10px
      .button-new-tag
        margin-left 10px
        height 32px
        line-height 30px
        padding-top 0
        padding-bottom 0
      .input-new-tag
        width 90px
        margin-left 10px
        vertical-align bottom
</style>
<style lang="stylus">
.tag_tag
  height auto
  white-space normal
</style>
